import { render, staticRenderFns } from "./rejectedProjects.vue?vue&type=template&id=f5a7fefa&scoped=true&"
import script from "./rejectedProjects.vue?vue&type=script&lang=js&"
export * from "./rejectedProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a7fefa",
  null
  
)

export default component.exports